import {Message, MessageEntity} from "../../../model/message";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type MessageSelectorProps = {
    // selector props here
};

export const messageSelector = () => createSelector(
    [getUseQueryResultData<Message>],
    (data) => {
        return data ? transformMessage(data) : undefined;
    }
);

export const messagesSelector = () => createSelector(
    [getUseQueryResultData<Message[]>],
    (data) => {
        return selectMessagesAndTransform(
            data ?? [], {}
        );
    }
);

export const transformMessage = (value: Message): MessageEntity => {
    return MessageEntity.from(value)
}

export const selectMessages = (values?: Message[], selector?: MessageSelectorProps): Message[] => {
    if (!values) {
        return [];
    }

    return values.filter((v) => {
        let filterIn = true;
        return filterIn;
    });
};

export const selectMessagesAndTransform = (values?: Message[], selector?: MessageSelectorProps): MessageEntity[] => {
    const selected = selectMessages(values, selector);
    return selected.map(transformMessage);
};
